module.exports = __webpack_public_path__ + "media/application/images/circle-twitter-62be6b0d0f0bfa0aa9f87ac9eb50cce5.svg";